import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['mobile', 'password', 'passwordConfirmation']

  run() {
    if (this.mobileTarget.value.length !==11) {
      alert('请输入正确的手机号')
      return
    }
    this.passwordTarget.value = this.mobileTarget.value.slice(-6)
    this.passwordConfirmationTarget.value = this.mobileTarget.value.slice(-6)
  }
}
